import { injectIntl } from 'react-intl';

import { xingConnect } from '@xingternal/xing-frame-provider';

import LegalFooter from './LegalFooter';
import legalSelector from './selector';

export default injectIntl(xingConnect(legalSelector)(LegalFooter));
